export const genderRoutes = {
	genders: (query: string) => `/product-genders/${query ? `?${query}` : ''}`,
	gender: (id: string) => `/product-genders/${id}/`,
	gendersDelete: '/product-genders/bulk_delete/'
} as const
